import builder from '../builder';
import ListBullets1 from '../../streamline-icons/bold/list-bullets-1.svg';

export default builder('IconListBullets1Bold', ListBullets1);
